export var storybookArgs = {
    pageChange: { action: "pageChange" },
    offcanvasswitch: { action: "offcanvasswitchEvent" },
    // layoutStatus: { action: "layoutStatus" },
    footerClick: { action: "footerClick" },
    navbarDropDownClick: { action: "navbarDropDownClick" },
    page_title: { control: { type: "text" } },
    contacts: { control: { type: "object" } },
    columns: { control: { type: "object" } },
    sidebar: { control: { type: "object" } },
    socials: { control: { type: "object" } },
    usermenu: { control: { type: "object" } },
    company: { control: { type: "object" } },
    navlinks: { control: { type: "array" } },
    pagename: { control: { type: "text" } },
    cookielawuri4more: { control: { type: "text" } },
    cookielawallowdecline: { control: { type: "boolean" } },
    cookielawlanguage: { control: { type: "text" } },
    cookielaw: { control: { type: "boolean" } },
    onescreen: { control: { type: "boolean" } },
    footer: { control: { type: "object" } },
    policies: { control: { type: "object" } },
    navbarSlotClick: { action: "navbarSlotClick" }
};
var cssVars = [
    { name: "--bs-primary", valueType: "color", theme: "bootstrap", defaultValue: "#07689f" },
    { name: "--bs-secondary", valueType: "color", theme: "bootstrap", defaultValue: "#c9d6df" },
    { name: "--bs-success", valueType: "color", theme: "bootstrap", defaultValue: "#11d3bc" },
    { name: "--bs-info", valueType: "color", theme: "bootstrap", defaultValue: "#a2d5f2" },
    { name: "--bs-warning", valueType: "color", theme: "bootstrap", defaultValue: "#ffc107" },
    { name: "--bs-danger", valueType: "color", theme: "bootstrap", defaultValue: "#f67280" },
];
export var cssParts = [
    { name: "footer", description: "" },
    { name: "container", description: "" },
    { name: "navbar", description: "" },
    { name: "page", description: "" },
];
export var htmlSlots = [
    { name: "nav-left-slot", description: "" },
    { name: "nav-center-slot", description: "" },
    { name: "nav-right-slot", description: "" },
    { name: "page", description: "" },
    { name: "nav-header-slot", description: "" },
];
export var i18nLanguages = [
    { lang: "it", language: "italian" },
    { lang: "en", language: "english" },
];
export var styleSetup = {
    vars: cssVars,
    parts: cssParts
};
var company = {
    logoUri: "https://upload.wikimedia.org/wikipedia/commons/8/80/Wikipedia-logo-v2.svg",
    siteName: "testsite",
    companyName: "testcompany S.R.L.",
    registration: { text: "copyright" },
    description: "testo e descrizione di esempio dell applicazione",
    vatNumber: "aa - ffffff",
    fiscalCode: "f4f5f6fff"
};
var navlinks = [
    {
        label: "Home",
        key: "home",
        icon: "house-door",
        badge: {
            text: "bbb"
        }
    },
    {
        label: "Dashboard",
        key: "dashboard",
        icon: "speedometer",
        badge: {
            text: "bbb"
        }
    },
    {
        label: "Settings",
        key: "settings",
        icon: "gear",
        group: "admin",
        badge: {
            text: "bbb"
        }
    },
    {
        label: "Users",
        key: "users",
        icon: "people-fill",
        group: "admin",
        badge: {
            text: "uuuuu"
        }
    },
    {
        label: "Stats",
        key: "stats",
        icon: "graph-up",
        group: "stats",
        badge: {
            text: "bbb"
        }
    },
];
var contacts = {
    sites: [
        {
            label: "dariocaruso.info",
            uri: "https://dariocaruso.info"
        },
    ],
    phones: [
        {
            number: "6666666666666"
        },
    ],
    addresses: [],
    emails: []
};
var usermenu = {
    list: [
        {
            key: "list1",
            label: "list1"
        },
        {
            key: "list2",
            label: "list2"
        },
        {
            key: "list3",
            label: "list3",
            group: "list1",
            badge: 3
        },
        {
            key: "list4",
            label: "list4",
            badge: 555
        },
    ],
    imgUri: "https://upload.wikimedia.org/wikipedia/commons/8/80/Wikipedia-logo-v2.svg"
};
var socials = {
    facebook: "fbbb",
    youtube: "yttttttt"
};
var sidebar = { title: "ciao" };
var policies = [
    {
        label: "Privacy Policy",
        key: "privacypolicy"
    },
    {
        label: "Cookie Policy",
        key: "cookiepolicy"
    },
];
var examples = [
    {
        name: "default",
        data: {
            company: company,
            contacts: contacts,
            socials: socials,
            navlinks: navlinks,
            usermenu: usermenu,
            sidebar: sidebar,
            policies: policies
        }
    },
];
export var componentSetup = {
    definitions: null,
    storybookArgs: storybookArgs,
    styleSetup: styleSetup,
    author: null,
    contributors: [],
    owner: null,
    htmlSlots: htmlSlots,
    i18n: i18nLanguages,
    examples: examples,
    screenshots: [],
    licenses: [{ type: "Apache-2.0", path: "LICENSE.md", cost: 0, currency: "EUR" }],
    readmePath: "README.md",
    name: "hb-layout",
    category: "layout",
    tags: ["layout"],
    size: { layout: "fullscreen" },
    iifePath: "release/release.js",
    repoName: "@htmlbricks/hb-layout",
    version: null
};
//# sourceMappingURL=docs.js.map